import {Favorite, Home, Search} from '@mui/icons-material';
import {Badge, BottomNavigation, BottomNavigationAction} from '@mui/material';
import {FC, useMemo} from 'react';
import {styled} from 'styled-components';
import {useLocation} from 'wouter';

import {useLikedIds} from '@website_frontend/lib/user_data_storage';

export const AppBottomNavigation: FC = () => {
  const [location, setLocation] = useLocation();
  const likedIds = useLikedIds();
  const likedCount = likedIds.length;

  // Determine current route value
  const currentValue = useMemo(() => {
    if (location === '/') return 'home';
    if (location === '/liked') return 'liked';
    if (location === '/searches') return 'searches';
    return 'home';
  }, [location]);

  const handleChange = (_event: unknown, newValue: string) => {
    switch (newValue) {
      case 'home':
        setLocation('/');
        break;
      case 'liked':
        setLocation('/liked');
        break;
      case 'searches':
        setLocation('/searches');
        break;
    }
  };

  return (
    <StyledBottomNavigation value={currentValue} onChange={handleChange} showLabels>
      <BottomNavigationAction label="Accueil" value="home" icon={<Home />} />
      <BottomNavigationAction
        label="Favoris"
        value="liked"
        icon={
          <Badge badgeContent={likedCount} color="error" max={99}>
            <Favorite />
          </Badge>
        }
      />
      <BottomNavigationAction label="Recherches" value="searches" icon={<Search />} />
    </StyledBottomNavigation>
  );
};

AppBottomNavigation.displayName = 'AppBottomNavigation';

const StyledBottomNavigation = styled(BottomNavigation)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  
  /* Ensure proper spacing on mobile */
  padding-bottom: env(safe-area-inset-bottom);
`;
